import { gql } from '@apollo/client'

const MENU_TITLE_DISH_COUNTS_QUERY = gql`
  query menuTitleDishCountsQuery($filters: DishFiltersInput!) {
    menuTitleDishCounts(filters: $filters) {
      menuTitleId
      count
    }
  }
`

export default MENU_TITLE_DISH_COUNTS_QUERY
